import { render, staticRenderFns } from "./MessengerChannelDetail.vue?vue&type=template&id=820db644&scoped=true"
import script from "./MessengerChannelDetail.vue?vue&type=script&lang=js"
export * from "./MessengerChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./MessengerChannelDetail.vue?vue&type=style&index=0&id=820db644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820db644",
  null
  
)

export default component.exports